import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {DataService} from '../../../services/data.service';
import {Page, Pages} from '../../../services/data.model';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent {

  public pages: Pages = undefined;
  public pageSlug: string;

  constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router) {
    this.dataService.pages.subscribe((pages: Page[]) => {
      if (pages.length) {
        this.pages = {};
        const tempPages = {};
        let pageSlug = this.route.snapshot.paramMap.get('pageSlug');
        let slugFound = false;

        pages.forEach(item => {
          tempPages[item.slug] = item;
          if (item.slug === pageSlug) {
            slugFound = true;
          }
        });

        this.pages = tempPages;
        this.pageSlug = pageSlug;

        if (!slugFound) {
          this.router.navigate(['404']);
        }

        this.route.paramMap.subscribe((map: any) => {
          pageSlug = map.params.pageSlug;

          if (typeof tempPages[pageSlug] === 'undefined') {
            this.router.navigate(['404']);
          }

          this.pageSlug = pageSlug;
        });
      }
    });
  }
}
